import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import $ from 'jquery';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import { checkCrmPermission, maskEmail } from '../crm/customer/Utility';
import RsuiteChecker from '../RsuiteChecker';

class AskSales extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.crmPermission = checkCrmPermission();
        this.state = {
            contactus: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            activePage: 1,
            item_count: '',
            message: '',
            fromdate: '',
            todate: '',
            from_date: '',
            to_date: '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            search: '',
            isLoadMore: 1,
            loading: 1,
            showFilter: false,
            sources: [],
            selectedSources: [],
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.formdateChange = this.formdateChange.bind(this);
        this.getSourceLink = this.getSourceLink.bind(this);
        this.todateChange = this.todateChange.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
    }

    toggleFilter() {
        this.setState({ showFilter: !this.state.showFilter });
    }

    fetchSources() {
        fetch(this.state.apiUrl + '/AdvancedRest/GetSources')
            .then((res) => res.json())
            .then((res) => {
                const data = this.decrypt(res, 1);
                const formatted = data.sources.map((src) => ({
                    id: src,
                    value: src
                }));
                console.log('Fetched Sources:', formatted); // 🔍 Check what comes back

                this.setState({ sources: formatted });
            });
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    formdateChange(event) {
        this.setState({
            fromdate: event,
            from_date: moment(event).format("YYYY-MM-D"),
            activePage: 1
        }, function () {
            this.contactList();
        });
    }
    todateChange(event) {
        this.setState({
            todate: event,
            to_date: moment(event).format("YYYY-MM-D"),
            activePage: 1
        }, function () {
            this.contactList();
        });
    }

    getSourceLink(link) {
        if (link) {
            if (link.indexOf('http') !== -1) {
                var linknew = <a href={`${link}`}>{`${link}`}</a>;
                return linknew
            }
            else { return link }
        } else {
            return 'NA';
        }
    }

    keywordChange(event) {
        var obj = this;
        this.setState({ search: event.target.value, activePage: 1 });
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            obj.contactList();
        }, 1000);
    }
    
    back() {
        window.location.href = '/ask-sales/list';
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = (this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/AdvancedRest/AskSales/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        contactus: findresponse.contactus,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    contactList(page = 1) {
        fetch(this.state.apiUrl + '/AdvancedRest/AskSales/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    loading: 0,
                    contactus: findresponse.contactus,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }

    export() {
        var win = window.open(this.state.apiUrl + "/AskSales/ExportAdvanced/userAuthKey/" + this.state.userAuthKey + "/type/contactus/fromdate/" + this.state.from_date + "/todate/" + this.state.to_date + "/search/" + this.state.search, '_self');
        win.focus()
    }

    componentDidMount() {
        document.title = "Intranet | Ask Sales";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.fetchSources();
        this.contactList();
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function () {
                //ticketsList();
                // window.location.reload();
            }, 10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function () {
                $(this).closest('.intranet_body').find('.form-section').slideToggle('slow');
            });
        });
    }

    getCustomerDetails() {
        const { contactus, loading, item_count, offset, off_count, activePage } = this.state;

        const getDate = (timestamp) => {
            const date = new Date(timestamp);
            const utcDateString = date.toISOString().split("T")[0];
            return new Date(utcDateString).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
            });
        };

        return (
            <div className="ask-sales-wrapper">
                <div className="body-content">
                    <div className="table-wrap">
                        <table style={{ tableLayout: "fixed" }}>
                            <thead>
                                <tr>
                                    <th width="100">Name</th>
                                    <th width="100">Company</th>
                                    <th width="100">Email</th>
                                    <th width="100">Phone</th>
                                    <th width="100">Message</th>
                                    <th width="100">Source</th>
                                    <th width="100">Extranet Source</th>
                                    <th width="100">Ask Sales File</th>
                                    <th width="100">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: "center", height: "370px" }}>
                                            <div className="loader-new"></div>
                                        </td>
                                    </tr>
                                ) : contactus.length > 0 ? (
                                    contactus.map((contact, key) => (
                                        <tr key={key}>
                                            <td>{contact.name}</td>
                                            <td>{contact.company}</td>
                                            <td>
                                                {
                                                    this.crmPermission ? (
                                                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                                    ) : (
                                                        <React.Fragment>
                                                            {
                                                                contact.email && contact.email.length > 50
                                                                    ? maskEmail(contact.email.slice(0, 50) + "...", 2, "email")
                                                                    : maskEmail(contact.email, 2, "email")
                                                            }
                                                        </React.Fragment>
                                                    )
                                                }
                                            </td>
                                            <td>
                                                {
                                                    contact.phone && contact.phone.length > 15
                                                        ? maskEmail(contact.phone.slice(0, 15) + "...", 2, "phone_number")
                                                        : maskEmail(contact.phone, 2, "phone_number")
                                                }
                                            </td>
                                            <td>{contact.message}</td>
                                            <td>{this.getSourceLink(contact.source)}</td>
                                            <td class="text-inded">{this.getSourceLink(contact.extranet_source)}</td>
                                            <td class="text-inded">{this.getSourceLink(contact.ask_sale_file)}</td>
                                            <td>{getDate(contact.created_date)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            <div className="no-data-found">No Data Found</div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {item_count > 0 && (
                        <div className="d-flex mu-pagination justify-content-between align-items-center" aria-label="Page navigation example">
                            <div className="txt-dark">
                                Showing {offset + 1} - {offset + off_count} of {item_count}
                            </div>
                            <div className="mu-pagination">
                                <Pagination
                                    activePage={activePage}
                                    itemsCountPerPage={20}
                                    totalItemsCount={item_count}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={this.handlePageChange}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    handleApply = (event, picker) => {
        picker.element.val(
            picker.startDate.format('DD/MM/YYYY') +
            ' - ' +
            picker.endDate.format('DD/MM/YYYY')
        );
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-D'),
            to_date: picker.endDate.format('YYYY-MM-D')
        }, () => {
            this.contactList()
        })
    };


    applyHandler = (event, picker) => {
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-D'),
            to_date: picker.endDate.format('YYYY-MM-D')
        }, () => {
            this.contactList()
        })
    }

    handleCallback(start, end, label) {
        console.log(start, end, label);
    }

    handleEvent = (event, picker) => {
        this.setState({
            inputStart: picker.startDate.format('YYYY/MM/D'),
            inputFinish: picker.endDate.format('YYYY/MM/D')
        });
    }

    onCancel = (event, picker) => {

        this.setState({

            from_date: '',
            to_date: ''
        }, () => {

            this.contactList();
            picker.element.val(
                'From Date - To Date'
            );


        })
    }

    onSelectedSourcesChanged = (evt, field) => {
        this.setState({
            selectedSources: evt
        }, () => {
            this.contactList()
        })
    };

    render() {
        if (this.state.redirect) {
            return <Redirect to={'/login'} />;
        }

        return (
            <div>
                <Header brecum_name="Ask Sales" brecum_page="Ask Sales" />
                <div className="right_col">
                    <div className="customer-wrap">
                        <div className="page-top">
                            <div className="containerfull">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-center mt-10">
                                            <h2>Ask Sales</h2>
                                            <span className="badge-blue">{this.state.item_count}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex">
                                            <div className="lct-form-group">
                                                <input
                                                    placeholder="Search Name or Company or Email or Phone or Message"
                                                    type="text"
                                                    className="form-control input-f"
                                                    name="customer"
                                                    id="customer"
                                                    autoComplete="off"
                                                    onChange={this.keywordChange}
                                                />
                                                <button type="submit">
                                                    <svg
                                                        width="18"
                                                        height="19"
                                                        viewBox="0 0 18 19"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z"
                                                            stroke="white"
                                                            strokeWidth="1.33"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M15.75 16.25L12.4875 12.9875"
                                                            stroke="white"
                                                            strokeWidth="1.33"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div
                                                id="toggle-btnf"
                                                className={"toogle-btn" + (this.state.showFilter ? " collapse-state" : "")}
                                                onClick={this.toggleFilter}
                                            >
                                                <svg
                                                    width="20"
                                                    height="17"
                                                    viewBox="0 0 20 17"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.83333 12.5H11.1667V11.3571H7.83333V12.5ZM4.5 9.07143H14.5V7.92857H4.5V9.07143ZM2 4.5V5.64286H17V4.5H2Z"
                                                        fill="#303049"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.state.showFilter && (
                            <div id="adv_filter" className="adv_filter filter-wrap show">
                                <div className="containerfull">
                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <label className="input-label">Date</label>
                                            <DateRangePicker
                                                initialSettings={{
                                                    showDropdowns: true,
                                                    autoUpdateInput: false,
                                                    linkedCalendars: false,
                                                    locale: { cancelLabel: 'Clear' },
                                                }}
                                                onCallback={this.handleCallback}
                                                onApply={this.handleApply}
                                                onEvent={this.handleEvent}
                                                onCancel={this.onCancel}
                                            >
                                                <input
                                                    className="form-control input-f date-box"
                                                    placeholder="From Date - To Date"
                                                />
                                            </DateRangePicker>
                                        </div>

                                        <div className="col-md-3">
                                            <label className="input-label">Source</label>
                                            <div className="position-relative">
                                                <RsuiteChecker
                                                    data={this.state.sources || []}
                                                    onChange={this.onSelectedSourcesChanged}
                                                    field_name="campaign_source"
                                                    val={this.state.selectedSources && this.state.selectedSources}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="intranet_body" style={{ marginTop: '5px' }}>
                            {this.getCustomerDetails && this.getCustomerDetails()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default AskSales


// WEBPACK FOOTER //
// ./src/components/advanced/AskSales.js